module.exports = __webpack_public_path__ + "static/media/logo.01ede7c8.svg";